import { render, staticRenderFns } from "./PageUserSupport.vue?vue&type=template&id=4f60b156&scoped=true"
import script from "./PageUserSupport.vue?vue&type=script&lang=js"
export * from "./PageUserSupport.vue?vue&type=script&lang=js"
import style0 from "./PageUserSupport.vue?vue&type=style&index=0&id=4f60b156&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f60b156",
  null
  
)

export default component.exports